export default [{
    path: 'workforce',
    name: 'workforce-dashboard',
    component: () => import ('source/pages/root/WorkforcePageGroup.vue'),
    meta: {
        title: 'Workforce - HQZen',
        canDisplayGlobalModals: true
    },
    children: [{
        path: 'service-contract/:contract_id',
        name: 'workforce-service-contract',
        component: () => import ('source/pages/employers/ServiceContractSection.vue'),
        props: true,
        meta: {
            title: 'Service Contract - HQZen',
        }
    }, {
        path: 'updates',
        name: 'workforce-dashboard-updates',
        component: () => import ('source/pages/employers/updates/UpdatesSection.vue'),
        props: true,
        meta: {
            title: 'Updates - HQZen',
            canDisplayGlobalModals: true
        },
    },{
        path: 'facility/lease-contract',
        name: 'employer-dashboard-facility-lease',
        component: () => import ('source/pages/employers/facility/FacilityLeaseSection.vue'),
        props: true,
        meta: {
            title: 'Lease Contract - HQZen',
            canDisplayGlobalModals: true
        },
    }, {
        path: 'reservations',
        name: 'workforce-reservations',
        component: () => import ('source/pages/employers/facility/WorkforceFacilityReservations.vue'),
        props: true,
        meta: {
            title: 'Reservations - HQZen',
            canDisplayGlobalModals: true
        },
    }, {
        path: 'reservation-room/:amenity_room_id/',
        name: 'employer-dashboard-reservation-room',
        component: () => import ('source/pages/employers/reservations/ReservationRoomSection.vue'),
        props: true,
        meta: {
            title: 'Amenity Details - HQZen',
            canDisplayGlobalModals: true
        },
    }]
},];
